/**
 * Decodes a JWT's payload without verifying its signature.
 * Verification isn't needed here: the token was already validated by the API,
 * this is only used to read non-sensitive claims (e.g. the current user id)
 * client-side for UX purposes.
 * @param {string} token The JWT
 * @returns {object|null} The decoded payload, or null if it can't be parsed
 */
export function decodeJwtPayload(token) {
  const payload = token?.split(".")[1];
  if (!payload) {
    return null;
  }

  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}
